(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gm-product-quick-facts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gm-product-quick-facts')) {
    customElements.define(
      'gm-product-quick-facts',
      class GmProductQuickFacts extends HTMLElement {
        variantChangeUnsubscriber = undefined;

        connectedCallback() {
          this.sectionId = this.closest('product-info')?.dataset.section;

          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId) return;

            const productInfo = event.data.html.querySelector(`product-info[data-section="${this.sectionId}"]`);
            const source = productInfo?.querySelector('gm-product-quick-facts');
            if (!source) return;

            this.innerHTML = source.innerHTML;
            this.toggleAttribute('hidden', source.hasAttribute('hidden'));
          });
        }

        disconnectedCallback() {
          this.variantChangeUnsubscriber?.();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
